import * as React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface CardProps {
  children: React.ReactNode;
  style?: any;
}

export const Card = ({ children, style }: CardProps) => {
  const { styles } = useStyles(stylesheet);

  return <View style={[styles.container, style]}>{children}</View>;
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    borderRadius: 24,
    backgroundColor: theme.colors.card.default.backgroundColor,
    borderColor: theme.colors.card.default.borderColor,
    borderWidth: 1,
  },
}));
